import {copilot} from '@cl/shared';
import accountAnalyticsAgent from 'common/src/modules/analytics/copilot/agents/accountAnalyticsAgent/accountAnalyticsAgent';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import accountAnalyticsSkill from 'common/src/modules/shared/copilot/skills/definitions/accountAnalyticsSkill';
import {registerSkill} from 'common/src/modules/shared/copilot/skills/skillRegistry';
import {CLStore} from 'common/src/redux/store';

function initializeAnalyticsAgents(store: CLStore) {
  if (isFlagEnabled(FeatureFlagKey.EnableCopilotAccountAnalyticsAgent)) {
    if (!isFlagEnabled(FeatureFlagKey.EnableCopilotSkills)) {
      copilot.registerAgent(accountAnalyticsAgent(store));
    }

    registerSkill(accountAnalyticsSkill(store));
  }
}

export default initializeAnalyticsAgents;
